// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"98":"689cc850","208":"b151afff","508":"812af476","564":"ec8f1806","584":"f990a0cc","594":"7292408a","619":"5c78cf03","844":"e6ec12a3","889":"4f7b4660","943":"e7a88346"}[chunkId] + ".js";
};